import { Box, SxProps, Theme, alpha } from "@mui/material";
import React from "react";

interface DotProgressProps {
  sx?: SxProps<Theme>;
  dotColor: string;
}

export const DotProgress: React.FC<DotProgressProps> = ({ sx, dotColor }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        p: 1,
        ...sx,
      }}
    >
      {[1, 2, 3].map((dot) => (
        <Box
          key={dot}
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor:
              dot === 1
                ? dotColor
                : dot === 2
                  ? alpha(dotColor, 0.5) // 50% opacity
                  : alpha(dotColor, 0.2), // 20% opacity
            animation: "dot-pulse 1s infinite",
            animationDelay: `${(dot - 1) * 0.3}s`,
            "@keyframes dot-pulse": {
              "0%, 100%": {
                transform: "scale(1)",
              },
              "50%": {
                transform: "scale(1.2)",
                backgroundColor: dotColor,
              },
            },
          }}
        />
      ))}
    </Box>
  );
};
